<template>
    <div
        class="MetaData"
    >
        <div
            v-if="published && date"
            class="MetaData__published sub">
            Published on
            <strong>{{ date }}</strong>
            <span v-if="tags">under:</span>
        </div>

        <div
            class="MetaData__tags mt-small"
            v-if="tags || (date && !published)"
        >
            <BaseTag
                v-if="!published && date"
                class="BaseTag--ghost"
                :title="date"
            />

            <BaseTag
                v-for="tag in tags"
                :key="tag.id"
                :title="tag.title"
            />
        </div>
    </div>
</template>
<script>

export default {
    name: 'MetaData',
    props: {
        published: {
            type: Boolean,
            default: false
        },
        date: {
            type: String,
        },
        tags: {
            type: Array,
        }
    }
}
</script>

<style lang="scss" scoped>

    .MetaData__published {
        border-top: 2px solid getColor('lightblue');
        padding-top: getSpacing(spacer);
    }

    .MetaData__tags {
        display: flex;
    }

    .BaseTag {
        margin-right: 0.5rem;
    }
    // .MetaData {
    //     padding-top: 1.4rem;
    //     border-top: 2px solid getColor('lightblue');
    // }
    //     .MetaData__tags {
    //         display: flex;
    //         flex-wrap: wrap;
    //         margin-top: getSpacing('small');

    //         a {
    //             display: flex;
    //             align-items: center;
    //             margin-bottom: getSpacing('small');
    //             margin-right: 0.8em;
    //             padding: 0.3em 0.7em;
    //             background-color: getColour('lightblue');
    //             line-height: 1em;
    //             border-radius: 50px;
    //         }
    //     }

    //     .MetaData__inline-date {
    //         display: none;
    //     }

    // .MetaData--inline {
    //     display: flex;
    //     flex-wrap: wrap;
    //     align-items: center;
    //     padding-top: 0;
    //     border-top: none;
    //     margin-top: 1.5rem;

    //     .MetaData__date-text {
    //         display: none;
    //     }

    //     .MetaData__inline-date {
    //         display: flex;
    //         margin-right: 0.8em;
    //         padding: 0.3em 0.7em;
    //         margin-bottom: getSpacing('small');
    //         border: 1px solid rgba(255,255,255,0.3);
    //         color: getColour('white');
    //         font-size: 0.6rem;
    //         border-radius: 50px;
    //         line-height: 1em;
    //     }

    //     .MetaData__tags {
    //         margin-top: 0;
    //     }

    // }

    // .MetaData--neg-m-top {
    //     @include media-query(desk) {
    //         margin-top: -3.5rem;
    //     }
    // }
</style>
